import moment from 'moment';
import 'moment/min/locales';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import '../../assets/css/timeline.css';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js';
import Loading from '../ui/Loading.js';

class SafeFeedbackFormularioHistorico extends Component {
  constructor(props) {
    super(props);

    this.ajaxHandler = new AjaxHandler();
    moment.locale('es');

    this.state = {
      loading: false,
      historia: [],
    };
  }

  componentDidMount() {
    this.ajaxHandler.subscribe(this);
    this.loadFormData();
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  loadFormData() {
    const formularioId = this.props.formulario ? this.props.formulario.id : null;
    if (!formularioId) return;

    const component = this;
    this.setState({ loading: true });
    this.ajaxHandler
      .getJson('/safe-feedback-formularios/' + formularioId + '/historico')
      .then((data) => {
        component.setState({ historia: data || [], loading: false });
      });
  }

  getUsuarioDisplay(item) {
    if (item && (item.per_nombre || item.per_apellido)) {
      let nombre = item.per_apellido || '';
      if (item.per_nombre) nombre = nombre ? nombre + ', ' + item.per_nombre : item.per_nombre;
      return nombre;
    }
    if (item && item.usuario_nombre) return item.usuario_nombre;
    return this.props.intl.formatMessage({
      id: 'safeFeedbackFormularioHistorico.usuario.sistema',
      defaultMessage: 'Generado por el sistema',
    });
  }

  getAccionLabel(accion) {
    if (accion === 'CONFIRMADO') {
      return this.props.intl.formatMessage({
        id: 'safeFeedbackFormularioHistorico.accion.confirmado',
        defaultMessage: 'Confirmado',
      });
    }
    if (accion === 'DESESTIMADO') {
      return this.props.intl.formatMessage({
        id: 'safeFeedbackFormularioHistorico.accion.desestimado',
        defaultMessage: 'Desestimado',
      });
    }
    return accion;
  }

  render() {
    if (!this.props.formulario) return null;

    return (
      <React.Fragment>
        {this.state.loading && <Loading />}
        <div className="content-wrapper">
          <div className="content-body">
            <section id="timeline" className="timeline-left timeline-wrapper">
              <ul className="timeline">
                <li className="timeline-line"></li>
                {!this.state.loading && (!this.state.historia || this.state.historia.length === 0) && (
                  <li className="timeline-item">
                    <div className="timeline-card card border-grey border-lighten-2 card-history">
                      <div className="card-header">
                        <h4 className="card-title">
                          {this.props.intl.formatMessage({
                            id: 'safeFeedbackFormularioHistorico.sinAcciones',
                            defaultMessage: 'Sin acciones registradas.',
                          })}
                        </h4>
                      </div>
                    </div>
                  </li>
                )}
                {this.state.historia.map((item, index) => {
                  const usuario = this.getUsuarioDisplay(item);
                  const accionLabel = this.getAccionLabel(item.accion);
                  const esConfirmado = item.accion === 'CONFIRMADO';

                  return (
                    <li key={index} className={esConfirmado ? 'timeline-item status-change' : 'timeline-item'}>
                      <div className="timeline-badge">
                        <span className="bg-fleet bg-lighten-1" data-toggle="tooltip" data-placement="right">
                          <i className={esConfirmado ? 'la la-check' : 'la la-times'}></i>
                        </span>
                      </div>
                      <div className="timeline-card card border-grey border-lighten-2 card-history">
                        <div className="card-header">
                          <h4 className="card-title">
                            {moment(item.created_at).format('L') + ' - ' + accionLabel + ' - ' + usuario}
                          </h4>
                          {item.comentario && (
                            <p className="card-subtitle text-muted pt-1">
                              <span className="font-small-3">
                                <FormattedMessage
                                  id="safeFeedbackFormularioHistorico.comentario"
                                  defaultMessage="Comentario"
                                />
                                {': ' + item.comentario}
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </section>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(SafeFeedbackFormularioHistorico);
